import { createContext, ReactNode } from 'react';
import { useImmerReducer } from 'use-immer';

import {
  IHomepageTabDispatch,
  IHomepageTabState,
  homepageTabReducer,
} from 'homepage/state/homepageTabReducer';

export const HomepageTabStateContext = createContext<IHomepageTabState>(null);
export const HomepageTabDispatchContext = createContext<IHomepageTabDispatch>(null);

interface IHomepageTabProvider {
  children: ReactNode;
}

export const HomepageTabProvider = ({ children }: IHomepageTabProvider) => {
  const initialValues = {
    activeTab: null,
    currentSearchLandingFeedData: null,
    homepageScrollPosition: 0,
    isDiscoverTabOpen: false,
    isLoading: false,
    openTabScrollPosition: 0,
    visitedByBackButton: false,
  };
  const [state, dispatch] = useImmerReducer(homepageTabReducer, initialValues);

  return (
    <HomepageTabDispatchContext.Provider value={dispatch}>
      <HomepageTabStateContext.Provider value={state}>{children}</HomepageTabStateContext.Provider>
    </HomepageTabDispatchContext.Provider>
  );
};
